export enum ModuleTypes {
    REQUESTS = "requests",
    STATISTICS = "statistics",
    INVOICING = "invoicing",
    APPOINTMENT = "appointment",
    MANAGEMENT = "management",
    CONTANTC = "contact",
}
